import { useWidgetStore } from "../store/widget-store";

const TABS = [
  { id: "chat", label: "Chat" },
  { id: "shop", label: "Shop" },
] as const;

export function TabBar() {
  const activeTab = useWidgetStore((state) => state.activeTab);
  const setActiveTab = useWidgetStore((state) => state.setActiveTab);

  return (
    <div className="flex border-b border-gray-200">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => setActiveTab(tab.id)}
          className={`flex-1 py-2 text-sm font-medium transition-colors ${
            activeTab === tab.id
              ? "border-b-2 border-brand text-brand"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
